// source: pbtypes/gen/planner/subject_focus_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
var pbtypes_gen_planner_image_space_settings_pb = require('../../../pbtypes/gen/planner/image_space_settings_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_image_space_settings_pb);
goog.exportSymbol('proto.planner.SubjectFocusSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.planner.SubjectFocusSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.planner.SubjectFocusSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.planner.SubjectFocusSettings.displayName = 'proto.planner.SubjectFocusSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.planner.SubjectFocusSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.planner.SubjectFocusSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.planner.SubjectFocusSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.SubjectFocusSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
azimuth: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
azimuthAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
azimuthDeadZone: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
azimuthDiscountingHalflife: jspb.Message.getFloatingPointFieldWithDefault(msg, 31, 0.0),
azimuthRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
azimuthRateAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
customSubjectPosition: (f = msg.getCustomSubjectPosition()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
customSubjectVelocity: (f = msg.getCustomSubjectVelocity()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f),
elevation: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
elevationAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
elevationDeadZone: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
elevationDiscountingHalflife: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
height: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
heightAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
imageSpace: (f = msg.getImageSpace()) && pbtypes_gen_planner_image_space_settings_pb.ImageSpaceSettings.toObject(includeInstance, f),
lineOfSightAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
lineOfSightMargin: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
maxRelativeHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
maxRelativeHeightEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
minRelativeHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
minRelativeHeightEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
rangeXy: jspb.Message.getFloatingPointFieldWithDefault(msg, 40, 0.0),
range: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
rangeAggressiveness: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
rangeDeadZone: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
rangeDiscountingHalflife: jspb.Message.getFloatingPointFieldWithDefault(msg, 37, 0.0),
transitionNonce: jspb.Message.getFieldWithDefault(msg, 2, 0),
useCustomSubject: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
disableGpsFollow: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
beaconEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
disableMaxRangeClamp: jspb.Message.getBooleanFieldWithDefault(msg, 34, false),
use2dTracking: jspb.Message.getBooleanFieldWithDefault(msg, 35, false),
gpsOnlyTrackEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
irSubjectTracking: jspb.Message.getBooleanFieldWithDefault(msg, 38, false),
ttidTracking: jspb.Message.getBooleanFieldWithDefault(msg, 39, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.planner.SubjectFocusSettings}
 */
proto.planner.SubjectFocusSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.planner.SubjectFocusSettings;
  return proto.planner.SubjectFocusSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.planner.SubjectFocusSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.planner.SubjectFocusSettings}
 */
proto.planner.SubjectFocusSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuthAggressiveness(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuthDeadZone(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuthDiscountingHalflife(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuthRate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAzimuthRateAggressiveness(value);
      break;
    case 25:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setCustomSubjectPosition(value);
      break;
    case 26:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setCustomSubjectVelocity(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElevation(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElevationAggressiveness(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElevationDeadZone(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElevationDiscountingHalflife(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeight(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeightAggressiveness(value);
      break;
    case 27:
      var value = new pbtypes_gen_planner_image_space_settings_pb.ImageSpaceSettings;
      reader.readMessage(value,pbtypes_gen_planner_image_space_settings_pb.ImageSpaceSettings.deserializeBinaryFromReader);
      msg.setImageSpace(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLineOfSightAggressiveness(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLineOfSightMargin(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxRelativeHeight(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMaxRelativeHeightEnabled(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinRelativeHeight(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMinRelativeHeightEnabled(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRangeXy(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRange(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRangeAggressiveness(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRangeDeadZone(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRangeDiscountingHalflife(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setTransitionNonce(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseCustomSubject(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableGpsFollow(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBeaconEnabled(value);
      break;
    case 34:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableMaxRangeClamp(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUse2dTracking(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGpsOnlyTrackEnabled(value);
      break;
    case 38:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIrSubjectTracking(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTtidTracking(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.planner.SubjectFocusSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.planner.SubjectFocusSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.planner.SubjectFocusSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.planner.SubjectFocusSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getAzimuth();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getAzimuthAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getAzimuthDeadZone();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getAzimuthDiscountingHalflife();
  if (f !== 0.0) {
    writer.writeDouble(
      31,
      f
    );
  }
  f = message.getAzimuthRate();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getAzimuthRateAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getCustomSubjectPosition();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getCustomSubjectVelocity();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
  f = message.getElevation();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getElevationAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getElevationDeadZone();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getElevationDiscountingHalflife();
  if (f !== 0.0) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getHeightAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getImageSpace();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      pbtypes_gen_planner_image_space_settings_pb.ImageSpaceSettings.serializeBinaryToWriter
    );
  }
  f = message.getLineOfSightAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getLineOfSightMargin();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getMaxRelativeHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getMaxRelativeHeightEnabled();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getMinRelativeHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getMinRelativeHeightEnabled();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getRangeXy();
  if (f !== 0.0) {
    writer.writeDouble(
      40,
      f
    );
  }
  f = message.getRange();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getRangeAggressiveness();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getRangeDeadZone();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getRangeDiscountingHalflife();
  if (f !== 0.0) {
    writer.writeDouble(
      37,
      f
    );
  }
  f = message.getTransitionNonce();
  if (f !== 0) {
    writer.writeSint64(
      2,
      f
    );
  }
  f = message.getUseCustomSubject();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getDisableGpsFollow();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getBeaconEnabled();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getDisableMaxRangeClamp();
  if (f) {
    writer.writeBool(
      34,
      f
    );
  }
  f = message.getUse2dTracking();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
  f = message.getGpsOnlyTrackEnabled();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getIrSubjectTracking();
  if (f) {
    writer.writeBool(
      38,
      f
    );
  }
  f = message.getTtidTracking();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double azimuth = 3;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getAzimuth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setAzimuth = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double azimuth_aggressiveness = 4;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getAzimuthAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setAzimuthAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double azimuth_dead_zone = 5;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getAzimuthDeadZone = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setAzimuthDeadZone = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double azimuth_discounting_halflife = 31;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getAzimuthDiscountingHalflife = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setAzimuthDiscountingHalflife = function(value) {
  return jspb.Message.setProto3FloatField(this, 31, value);
};


/**
 * optional double azimuth_rate = 6;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getAzimuthRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setAzimuthRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double azimuth_rate_aggressiveness = 7;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getAzimuthRateAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setAzimuthRateAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional eigen_lcm.Vector3dPb custom_subject_position = 25;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.planner.SubjectFocusSettings.prototype.getCustomSubjectPosition = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 25));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
*/
proto.planner.SubjectFocusSettings.prototype.setCustomSubjectPosition = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.clearCustomSubjectPosition = function() {
  return this.setCustomSubjectPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.hasCustomSubjectPosition = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional eigen_lcm.Vector3dPb custom_subject_velocity = 26;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.planner.SubjectFocusSettings.prototype.getCustomSubjectVelocity = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 26));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
*/
proto.planner.SubjectFocusSettings.prototype.setCustomSubjectVelocity = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.clearCustomSubjectVelocity = function() {
  return this.setCustomSubjectVelocity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.hasCustomSubjectVelocity = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional double elevation = 8;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getElevation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setElevation = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double elevation_aggressiveness = 9;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getElevationAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setElevationAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double elevation_dead_zone = 10;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getElevationDeadZone = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setElevationDeadZone = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double elevation_discounting_halflife = 32;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getElevationDiscountingHalflife = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setElevationDiscountingHalflife = function(value) {
  return jspb.Message.setProto3FloatField(this, 32, value);
};


/**
 * optional double height = 11;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double height_aggressiveness = 12;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getHeightAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setHeightAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional ImageSpaceSettings image_space = 27;
 * @return {?proto.planner.ImageSpaceSettings}
 */
proto.planner.SubjectFocusSettings.prototype.getImageSpace = function() {
  return /** @type{?proto.planner.ImageSpaceSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_planner_image_space_settings_pb.ImageSpaceSettings, 27));
};


/**
 * @param {?proto.planner.ImageSpaceSettings|undefined} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
*/
proto.planner.SubjectFocusSettings.prototype.setImageSpace = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.clearImageSpace = function() {
  return this.setImageSpace(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.hasImageSpace = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional double line_of_sight_aggressiveness = 14;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getLineOfSightAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setLineOfSightAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double line_of_sight_margin = 15;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getLineOfSightMargin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setLineOfSightMargin = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double max_relative_height = 16;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getMaxRelativeHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setMaxRelativeHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional bool max_relative_height_enabled = 17;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getMaxRelativeHeightEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setMaxRelativeHeightEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional double min_relative_height = 19;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getMinRelativeHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setMinRelativeHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional bool min_relative_height_enabled = 20;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getMinRelativeHeightEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setMinRelativeHeightEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional double range_xy = 40;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getRangeXy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 40, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setRangeXy = function(value) {
  return jspb.Message.setProto3FloatField(this, 40, value);
};


/**
 * optional double range = 21;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getRange = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setRange = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional double range_aggressiveness = 22;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getRangeAggressiveness = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setRangeAggressiveness = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional double range_dead_zone = 23;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getRangeDeadZone = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setRangeDeadZone = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional double range_discounting_halflife = 37;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getRangeDiscountingHalflife = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setRangeDiscountingHalflife = function(value) {
  return jspb.Message.setProto3FloatField(this, 37, value);
};


/**
 * optional sint64 transition_nonce = 2;
 * @return {number}
 */
proto.planner.SubjectFocusSettings.prototype.getTransitionNonce = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setTransitionNonce = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool use_custom_subject = 24;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getUseCustomSubject = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setUseCustomSubject = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool disable_gps_follow = 30;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getDisableGpsFollow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setDisableGpsFollow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional bool beacon_enabled = 33;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getBeaconEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setBeaconEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * optional bool disable_max_range_clamp = 34;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getDisableMaxRangeClamp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 34, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setDisableMaxRangeClamp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 34, value);
};


/**
 * optional bool use_2d_tracking = 35;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getUse2dTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setUse2dTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};


/**
 * optional bool gps_only_track_enabled = 36;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getGpsOnlyTrackEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setGpsOnlyTrackEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional bool ir_subject_tracking = 38;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getIrSubjectTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 38, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setIrSubjectTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 38, value);
};


/**
 * optional bool ttid_tracking = 39;
 * @return {boolean}
 */
proto.planner.SubjectFocusSettings.prototype.getTtidTracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.planner.SubjectFocusSettings} returns this
 */
proto.planner.SubjectFocusSettings.prototype.setTtidTracking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


goog.object.extend(exports, proto.planner);
